module.exports = ".row {\n    border: 1px solid #ccc;\n    margin: 10px 0;\n    padding: 10px 0;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/services/account/account.component.css
// module id = ./src/app/components/services/account/account.component.css
// module chunks = main